// extracted by mini-css-extract-plugin
export var iconRound = "StyledIcon-module--icon-round--hHiOp";
export var iconSmall = "StyledIcon-module--icon-small--2e6AF";
export var iconMedium = "StyledIcon-module--icon-medium--CWsvT";
export var iconLarge = "StyledIcon-module--icon-large--uik0d";
export var iconOutline = "StyledIcon-module--icon-outline--2P7vy";
export var insideBtn = "StyledIcon-module--inside-btn--ZnL9p";
export var insideBtnFa = "StyledIcon-module--inside-btn-fa--l4G0K";